module.exports = __webpack_public_path__ + "img/1 (121).cf769d73.png";